import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { StyledChipsDivider } from "app/pages/sales-intelligence/common-components/filters-panel/components/ChipsGroup/styles";

export const ADD_BUTTON_TOOLTIP_MAX_WIDTH = 260;

export const StyledAddButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 16px;
`;

export const StyledEmptyText = styled.p<{ isHidden: boolean }>`
    ${mixins.setFontVariant("caption", colorsPalettes.bluegrey[600])};
    display: ${({ isHidden }) => (isHidden ? "none" : "block")};
    line-height: normal;
    margin: 0;
`;

export const StyledSDKValueDivider = styled(StyledChipsDivider)`
    margin: 8px 0;
`;
